import { Component } from '@angular/core';
import { ProofType } from '../../../../models/ProofType';
import { RouterLink } from '@angular/router';
import { GenericTable, GenericTableAction, GenericTableColumn } from '../../../../models/GenericCRUD/GenericTable';
import { GenericForm, GenericFormField } from '../../../../models/GenericCRUD/GenericForm';
import { Paginator } from '../../../../models/Paginator';
import { GenericCRUD } from '../../../../models/GenericCRUD/GenericCRUD';
import { GenericCrudComponent } from "../../../../shared/components/generic-crud/generic-crud.component"
import { Filter } from '../../../../models/GenericCRUD/Filter';
import { BreadcrumbService } from '../../../../core/services/breadcrumb/breadcrumb.service';

@Component({
  selector: 'app-proof-type-configuration',
  standalone: true,
  imports: [
    GenericCrudComponent
  ],
  templateUrl: './proof-type-configuration.component.html',
  styleUrl: './proof-type-configuration.component.css'
})
export class ProofTypeConfigurationComponent {
  tableColums: GenericTableColumn[] = [
    { name: 'ID', active: false, type: 'text', key: 'id', sort: true },
    { name: 'Nombre', active: true, type: 'text', key: 'name', sort: true },
    { name: 'Tipo', active: true, type: 'text', key: 'type', sort: true },
    { name: 'Descripción', active: true, type: 'text', key: 'description', sort: false },
    { name: 'Fecha Creación', active: false, type: 'date', key: 'created_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
    { name: 'Fecha Modificación', active: false, type: 'date', key: 'updated_at', sort: true, format: 'dd/MM/yyyy hh:mm:ss' },
  ];

  formFields: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required', },
    { name: 'type', type: 'select', label: 'Tipo', validations: 'required', singleSelection: true, optionsList: [{ id: 'Teorico', name: 'Teorico' }, { id: 'Cerrado', name: 'Cerrado' }, { id: 'Abierto', name: 'Abierto' }] },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'license_id', type: 'select', label: 'Permiso oficial', validations: 'nullable', url: '/config/license/listAll', singleSelection: true },
  ];

  formFieldsEdit: GenericFormField[] = [
    { name: 'name', type: 'text', label: 'Nombre', validations: 'required' },
    { name: 'type', type: 'select', label: 'Tipo', validations: 'required', singleSelection: true, optionsList: [{ id: 'Teorico', name: 'Teorico' }, { id: 'Cerrado', name: 'Cerrado' }, { id: 'Abierto', name: 'Abierto' }] },
    { name: 'description', type: 'textarea', label: 'Descripción', colspan: 2 },
    { name: 'license_id', type: 'select', label: 'Permiso oficial', validations: 'nullable', url: '/config/license/listAll', singleSelection: true },
  ];


  form: GenericForm = {
    successTitle: 'Creación correcta',
    errorTitle: 'Error en la creación',
    method: 'POST',
    fields: this.formFields,
    name: 'tipo-de-prueba',
    createButtonTitle: 'Nuevo tipo de examen',
    cols: 2,
    createApiSlug: '/config/proof-type/store',
    formTitle: 'Crear tipo de examen',
    formButtonTitle: 'Crear tipo de examen',
    width: '4xl'
  }

  tableActions: GenericTableAction[] = [
    {
      name: 'Editar',
      key: 'edit',
      // actionSlug: '/config/office/update/{{id}}',
      form: {
        method: 'PUT',
        successTitle: 'Edición correcta',
        errorTitle: 'Error en la edición',
        fields: this.formFieldsEdit,
        name: 'tipo de examen',
        createButtonTitle: '',
        cols: 2,
        createApiSlug: '',
        originalUpdateApiSlug: '/config/proof-type/update/{{id}}',
        updateApiSlug: '',
        originalFormTitle: 'Editar {{name}}',
        formTitle: '',
        formButtonTitle: 'Editar',
        width: '4xl'
      },
      completeForm: true,
      replaceAllRowOnResponse: true,
      icon: '<svg  xmlns="http://www.w3.org/2000/svg" class="w-4 text-dark"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4" /><path d="M13.5 6.5l4 4" /><path d="M16 19h6" /></svg>',
      confirmation: false,

    },
    {
      name: 'Eliminar',
      key: 'delete',
      method: 'DELETE',
      icon: '<svg  xmlns="http://www.w3.org/2000/svg"  class="w-4 text-primary"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="1.8"  stroke-linecap="round"  stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M4 7l16 0" /><path d="M10 11l0 6" /><path d="M14 11l0 6" /><path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" /><path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" /></svg>',
      confirmation: true,
      questionText: '¿ Desea eliminar el tipo de examen ?',
      deleteRowOnResponse: true,
      actionSlug: '/config/proof-type/delete/{{id}}',
    }
  ]

  table: GenericTable<Paginator<ProofType>> = {
    columns: this.tableColums,
    items: [],
    type: 'generic',
    loadItemsSlug: '/config/proof-type/index',
    paginate: true,
    name: 'tipos-de-prueba',
    actions: this.tableActions
  };

  filters: Filter[] = [
    { type: 'search', key: 'name|description', operator: 'like', placeholder: 'Nombre o descripción' },
    { type: 'multiselect', key: 'type.name', operator: 'in', placeholder: 'Tipo', optionsList: [{ id: 'Cerrado', name: 'Cerrado' }, { id: 'Abierto', name: 'Abierto' }, { id: 'Teorico', name: 'Teórico' }], relation_filter_column: 'type' },
    { type: 'multiselect', key: 'license.name', operator: 'in', placeholder: 'Permiso oficial', url: '/config/license/listAll', relation_filter_column: 'license_id' },
    //{type: 'date-between', key: 'created_at', operator: 'between', parsed: "date-arr", placeholder: 'Fecha de creación'},
  ];

  genericCRUD: GenericCRUD<Paginator<ProofType>> = {
    genericForm: this.form,
    genericTable: this.table,
    genericFilters: this.filters,
    useModalForm: true
  }
}
